import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { SectionHeading } from './ui/SectionHeading';
import { questions } from '../data/faq';
export function FAQ() {
  const [open, setOpen] = useState(0);
  return <section className="py-20" aria-labelledby="faq-title" data-id="element-45" data-mp="1ceqcvl9bmtg8">
      <div className="mx-auto max-w-3xl px-4" data-id="element-46" data-mp="1cgb719rq4adk">
        <SectionHeading id="faq-title" data-id="element-47" data-mp="2a2s2sakt6fx7">Domande <span className="text-amber-400" data-id="element-48" data-mp="2a1qgf9yce706">frequenti</span></SectionHeading>
        <div className="mt-10 space-y-3" data-id="element-49" data-mp="252vwg4on2ceh">
          {questions.map(([question, answer], index) => {
          const isOpen = index === open;
          return <article key={question} className={`overflow-hidden rounded-xl border bg-slate-900 transition-colors duration-150 ease-out ${isOpen ? 'border-amber-400/60' : 'border-slate-800'}`} data-id="element-50" data-mp="2065hjkoklmun" data-mpi={index}>
                <h3 className="font-sans" data-id="element-51" data-mp="omt3e0tcgdia">
                  <button type="button" className="flex w-full items-center justify-between gap-5 px-5 py-5 text-left font-bold text-white transition-colors duration-150 ease-out hover:bg-slate-800 focus:outline-none focus-visible:ring-4 focus-visible:ring-inset focus-visible:ring-amber-400/50 sm:px-6" onClick={() => setOpen(isOpen ? -1 : index)} aria-expanded={isOpen} data-id="element-52" data-mp="jpjgosxcafy5">
                    <span data-id="element-53" data-mp="1fonajopoyvq8">{question}</span>
                    <ChevronDownIcon className={`h-5 w-5 shrink-0 text-amber-400 transition-transform duration-200 ease-out ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-54" data-mp="1fnlx5dl7dx5c" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-55" data-mp="16pa0ouxno54z">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.2,
                ease: [0.23, 1, 0.32, 1]
              }} data-id="element-56" data-mp="rzueztczepw5">
                      <p className="border-t border-slate-800 px-5 py-4 leading-relaxed text-slate-300 sm:px-6" data-id="element-57" data-mp="2pn599ghe3gj5">{answer}</p>
                    </motion.div>}
                </AnimatePresence>
              </article>;
        })}
        </div>
      </div>
    </section>;
}